import { makeStyles } from "@material-ui/core";
import { Stack, Typography } from "@mui/material";
import WalletComponent from "./walletComponent";
import PaymentForm from "./PaymentForm";
const useStyles = makeStyles((theme) => ({
  CustomBg: {
    width: "100%",
    borderRadius: "10px",
    border: "1px solid #DADADA",
    backgroundColor: "#FFFFFF",
    padding: "10px",
    marginTop: "10px",
    textAlign: "left",
  },
  TypographyClass: {
    fontSize: "16px",
    fontFamily: "vazir",

    "@media only screen and (max-width: 600px)": {
      fontSize: "14px !important",
    },
  },
  submit: {
    display: "flex",
    justifyContent: "center",
    borderRadius: "10px",
    width: "380px",
    marginTop: "40px",
    alignItems: "center",
    "@media only screen and (max-width: 600px)": {
      marginTop: "20px",
    },
  },
  HeadClass: {
    "&.MuiTypography-body1": {
      fontSize: "16px !important",
      fontFamily: "vazir",
      "@media only screen and (max-width: 600px)": {
        fontSize: "14px !important",
      },
    },
  },
}));
const RamzArzPayment = () => {
  const clasess = useStyles();

  return (
    <>
      <Stack className={clasess.CustomBg}>
        <Typography className={clasess.HeadClass}>حامی گرامی!</Typography>
        <Typography className={clasess.HeadClass}>
          برای حمایت از طریق رمز ارز:
        </Typography>
        <ol
          className={clasess.TypographyClass}
          style={{ paddingInlineStart: "20px" }}
        >
          <li> ابتدا آدرس wallet را کپی کنید.</li>
          <li>پرداخت خود را انجام دهید</li>
          <li>در پایان فرم زیر را با اطلاعات رسید خود تکمیل کنید</li>
        </ol>
      </Stack>
      <Stack className={clasess.CustomBg}>
        <WalletComponent />
      </Stack>
      <Stack className={clasess.CustomBg}>
        <PaymentForm />
      </Stack>
    </>
  );
};

export default RamzArzPayment;
